<div class="novo-cliente-list">
  <sgt-table-skeleton
    *ngIf="settings.loading"
    [columns]="skeletonColumns"
    [rows]="13"
  ></sgt-table-skeleton>

  <sgt-table
    *ngIf="!settings.loading"
    [settings]="settings"
    (scrollBottom)="onScrollBottom()"
  >
    <tr header>
      <ng-container *ngFor="let col of columns">
        <th
          *ngIf="!col.hidden || !col.hidden()"
          [class]="col.css"
          [style.cursor]="col.orderBy ? 'pointer' : 'default'"
          (click)="col.orderBy && sort(col.orderBy)"
        >
          {{ col.label }}
          <span *ngIf="col.orderBy" class="sort-icons">
            <i
              class="fas fa-sort-up"
              [ngClass]="{
                'current-sort': orderBy === col.orderBy && orderByDir === 'asc'
              }"
            ></i>
            <i
              class="fas fa-sort-down"
              [ngClass]="{
                'current-sort': orderBy === col.orderBy && orderByDir === 'desc'
              }"
            ></i>
          </span>
        </th>
      </ng-container>
      <th class="col-options">Ações</th>
    </tr>

    <!-- Body -->
    <ng-container body>
      <tr *ngFor="let cliente of clientes; trackBy: trackById">
        <!-- Código ERP -->
        <td class="col-codigo-integracao-erp text-center">
          {{ cliente.pessoa?.codigoIntegracaoErp }}
        </td>

        <!-- Nome -->
        <td class="col-nome">
          <span [sgtTooltip]="cliente.pessoa?.nome" tooltipPosition="top">{{
            cliente.pessoa?.nome | sgtTruncate: 30
          }}</span>
          <span
            *ngIf="!isRepresentante && !cliente.clientePrimario"
            class="badge badge-primary badge-cliente-secundario"
            sgtTooltip="Isto significa que este cliente foi cadastrado a partir de um outro cadastro de cliente com o mesmo CNPJ/CPF"
            tooltipPosition="top"
            >Secundário</span
          >
        </td>

        <!-- Nome Fantasia -->
        <td class="col-nome-fantasia">
          <span
            [sgtTooltip]="cliente.pessoa?.nomeFantasia"
            tooltipPosition="top"
            >{{ cliente.pessoa?.nomeFantasia | sgtTruncate: 25 }}</span
          >
        </td>

        <!-- CNPJ / CPF -->
        <td class="col-cnpj-cpf">{{ cliente.pessoa?.cnpjCpf }}</td>

        <!-- Representante -->
        <td class="col-nome-representante" *ngIf="!isRepresentante">
          <span
            [sgtTooltip]="
              cliente.representante?.pessoa?.nome
                | representanteNome
                  : cliente.representante?.pessoa?.nomeFantasia
                  : cliente.representante?.pessoa?.codigoIntegracaoErp
            "
            tooltipPosition="top"
            >{{
              cliente.representante?.pessoa?.nome
                | representanteNome
                  : cliente.representante?.pessoa?.nomeFantasia
                  : cliente.representante?.pessoa?.codigoIntegracaoErp
                | sgtTruncate: 22
            }}</span
          >
        </td>

        <!-- Gerente -->
        <td class="col-gerente">
          <span
            *ngIf="cliente.usuarioGerente; else gerenteVazio"
            [sgtTooltip]="cliente.usuarioGerente.nome"
            tooltipPosition="top"
            >{{ cliente.usuarioGerente.nome | sgtTruncate: 22 }}</span
          >
          <ng-template #gerenteVazio>-</ng-template>
        </td>

        <!-- Atendente -->
        <td class="col-atendente">
          <span
            *ngIf="cliente.usuarioAtendente; else atendenteVazio"
            [sgtTooltip]="cliente.usuarioAtendente.nome"
            tooltipPosition="top"
            >{{ cliente.usuarioAtendente.nome | sgtTruncate: 22 }}</span
          >
          <ng-template #atendenteVazio>-</ng-template>
        </td>

        <!-- Tipo Pessoa -->
        <td class="col-tipo-pessoa text-center">
          <sgt-pessoa-tipo-badge
            [tipo]="cliente.pessoa?.tipo"
            [quantidadeParticipantesCentralCompras]="
              cliente.quantidadeParticipantesCentralCompras
            "
          ></sgt-pessoa-tipo-badge>
        </td>

        <!-- Cadastro -->
        <td class="col-cadastro text-center">
          <span [class]="cliente.cadastro | clienteCadastroBadge">{{
            cliente.cadastro | clienteCadastro
          }}</span>
        </td>

        <!-- Situação -->
        <td class="col-situacao text-center">
          <span [class]="cliente.situacao | clienteSituacaoBadge">{{
            cliente.situacao | clienteSituacao
          }}</span>
        </td>

        <!-- Localização -->
        <td class="col-localizacao">
          <ng-container *ngIf="cliente.nomeCidade || cliente.uf">
            {{ cliente.nomeCidade }}{{ cliente.nomeCidade && cliente.uf ? ' - ' : '' }}{{ cliente.uf }}
          </ng-container>
        </td>

        <!-- Origem -->
        <td class="col-origem" [title]="cliente.origem | origem">
          <ng-container *ngIf="cliente.origem">
            <i [class]="cliente.origem | origemIcon"></i>
            <span>{{ cliente.origem | origem }}</span>
          </ng-container>
        </td>

        <!-- Canal Mídia Social -->
        <td class="col-canal-midia-social">
          <ng-container>
            <i [class]="cliente.canalMidiaSocial | canalMidiaSocialIcon"></i>
            <span>{{ cliente.canalMidiaSocial | canalMidiaSocial }}</span>
          </ng-container>
        </td>

        <!-- Campanha de Origem -->
        <td class="col-nome-campanha">
          <span
            [sgtTooltip]="cliente.nomeCampanhaOrigem"
            tooltipPosition="top"
            >{{ cliente.nomeCampanhaOrigem | sgtTruncate: 25 }}</span
          >
        </td>

        <!-- Campanha de Aquisição -->
        <td class="col-nome-campanha">
          <span
            [sgtTooltip]="cliente.nomeCampanhaAquisicao"
            tooltipPosition="top"
            >{{ cliente.nomeCampanhaAquisicao | sgtTruncate: 25 }}</span
          >
        </td>

        <!-- Status Análise Financeira -->
        <td
          class="col-status-analise-financeira text-center"
          *ngIf="canVisualizarAnaliseFinanceira"
        >
          <sgt-cliente-analise-financeira-status-badge
            [status]="cliente.statusAnaliseFinanceira"
          ></sgt-cliente-analise-financeira-status-badge>
        </td>

        <td class="col-options">
          <button
            *ngFor="let action of inlineActionsMap.get(cliente.id)"
            class="btn btn-link btn-sm"
            (click)="action.handler()"
            [sgtTooltip]="action.label"
            tooltipPosition="top"
          >
            <i [class]="action.icon" aria-hidden="true"></i>
          </button>

          <sgt-menu
            *ngIf="dropdownActionsMap.get(cliente.id)?.length > 0"
            class="table-options"
            [settings]="menuSettings"
          >
            <span
              trigger
              class="btn btn-link btn-options"
              sgtTooltip="Opções"
              tooltipPosition="top"
            >
              <i class="fas fa-ellipsis-h" aria-hidden="true"></i>
              <span class="sr-only">Opções</span>
            </span>

            <div items class="novo-cliente-list__actions-menu">
              <ng-container
                *ngFor="
                  let action of dropdownActionsMap.get(cliente.id);
                  let i = index
                "
              >
                <div
                  class="dropdown-divider"
                  *ngIf="i > 0 && (action.divider || action.groupLabel)"
                ></div>
                <h6 class="dropdown-header" *ngIf="i > 0 && action.groupLabel">
                  {{ action.groupLabel }}
                </h6>
                <a class="dropdown-item" (click)="action.handler()">
                  <i [class]="action.icon" aria-hidden="true"></i>
                  {{ action.label }}
                </a>
              </ng-container>
            </div>
          </sgt-menu>
        </td>
      </tr>

      <!-- Loading more indicator -->
      <tr *ngIf="isLoadingMore">
        <td
          [attr.colspan]="
            canVisualizarAnaliseFinanceira
              ? isRepresentante
                ? 16
                : 17
              : isRepresentante
                ? 15
                : 16
          "
          class="text-center"
        >
          <span>Carregando mais clientes...</span>
        </td>
      </tr>
    </ng-container>

    <!-- Empty -->
    <tr empty>
      <td
        [attr.colspan]="
          canVisualizarAnaliseFinanceira
            ? isRepresentante
              ? 16
              : 17
            : isRepresentante
              ? 15
              : 16
        "
        class="text-center"
      >
        Nenhum cliente encontrado
      </td>
    </tr>

    <!-- Footer -->
    <tr footer>
      <td
        [attr.colspan]="
          canVisualizarAnaliseFinanceira
            ? isRepresentante
              ? 16
              : 17
            : isRepresentante
              ? 15
              : 16
        "
        class="text-center"
      >
        {{ totalClientes | decimalFormat: 1 : 0 : 0 }} cliente(s)
      </td>
    </tr>
  </sgt-table>
</div>

<!-- Modal para concluir a Análise Financeira do Cliente -->
<sgt-cliente-analise-financeira-concluir-modal
  #analiseFinanceiraConcluirModal
  (afterConcluir)="onAfterConcluirAnaliseFinanceira()"
></sgt-cliente-analise-financeira-concluir-modal>

<!-- Modal para revisar a Análise Financeira do Cliente -->
<sgt-cliente-analise-financeira-revisar-modal
  #analiseFinanceiraRevisarModal
  (afterRevisar)="onAfterRevisarAnaliseFinanceira()"
></sgt-cliente-analise-financeira-revisar-modal>

<!-- Modal para congelar um cliente -->
<sgt-cliente-carteira-congelar-modal
  #clienteCarteiraCongelarModal
  [isRepresentante]="isRepresentante"
  (afterCongelar)="refresh()"
></sgt-cliente-carteira-congelar-modal>

<!-- Modal para pré-baixar um cliente -->
<sgt-cliente-carteira-prebaixar-modal
  #clienteCarteiraPreBaixarModal
  [isRepresentante]="isRepresentante"
  (afterInsertPreBaixa)="refresh()"
  (afterEditPreBaixa)="refresh()"
></sgt-cliente-carteira-prebaixar-modal>

<!-- Modal para baixar um cliente -->
<sgt-cliente-carteira-baixar-modal
  #clienteCarteiraBaixarModal
  [isRepresentante]="isRepresentante"
  subTitleInsert="Informe o motivo da baixa deste cliente"
  (afterInsertBaixa)="refresh()"
  (afterEditBaixa)="refresh()"
></sgt-cliente-carteira-baixar-modal>

<!-- Negócio Form Insert -->
<sgt-negocio-form-insert-modal #formInsertModal></sgt-negocio-form-insert-modal>
